'use strict';

$(window).on('load', function() {
    const $groupMain = $('#taydu-ld-25-taingotamgioi-daovien .group__main');

    let isScrolling = false;

    $groupMain.on('touchstart', function(e) {
        isScrolling = true;
        e.stopPropagation();
    });

    $groupMain.on('touchmove', function(e) {
        e.preventDefault();
        const touch = e.originalEvent.touches[0];
        const currentScrollTop = $groupMain.scrollTop();
        const scrollDelta = touch.clientY;

        // Cho phép scroll tự nhiên
        $groupMain[0].scrollTop = currentScrollTop;
    });

    $groupMain.on('touchend', function(e) {
        isScrolling = false;
        e.stopPropagation();
    });

    $groupMain.on('wheel', function(e) {
        e.stopPropagation();
    });
});